var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93994 5.50002C6.93968 6.03046 6.72871 6.53906 6.35345 6.91394C5.97819 7.28883 5.46937 7.49929 4.93894 7.49902C4.40851 7.49876 3.89991 7.28779 3.52502 6.91253C3.15014 6.53727 2.93968 6.02846 2.93994 5.49802C2.94021 4.96759 3.15117 4.45899 3.52644 4.0841C3.9017 3.70922 4.41051 3.49876 4.94094 3.49902C5.47137 3.49929 5.97998 3.71026 6.35486 4.08552C6.72975 4.46078 6.94021 4.96959 6.93994 5.50002ZM6.99994 8.98002H2.99994V21.5H6.99994V8.98002ZM13.3199 8.98002H9.33994V21.5H13.2799V14.93C13.2799 11.27 18.0499 10.93 18.0499 14.93V21.5H21.9999V13.57C21.9999 7.40002 14.9399 7.63002 13.2799 10.66L13.3199 8.98002Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c19e31618e415abcb68c504c4078ec0c.svg";
export { ForwardRef as ReactComponent };